/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2016] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';
import { default as BackbonePageableCollection } from 'backbone.paginator';

const PageableCollection = BackbonePageableCollection.extend({
  mode: 'client',

  initialize(models, options = { pageSize: 10, idAttribute: 'id' }) {
    const { pageSize, idAttribute } = options;
    this.state.pageSize = pageSize;
    this.model = Backbone.Model.extend({ idAttribute });
    return this;
  },
});

export default PageableCollection;
